module.exports = __webpack_public_path__ + "img/flag-sprites.6f661cb6.jpeg";